// News Generation Action Types
export const CREATE_NEWS_GENERATION_RECORD = "CREATE_NEWS_GENERATION_RECORD";
export const CREATE_NEWS_GENERATION_RECORD_SUCCESS =
  "CREATE_NEWS_GENERATION_RECORD_SUCCESS";
export const CREATE_NEWS_GENERATION_RECORD_FAILURE =
  "CREATE_NEWS_GENERATION_RECORD_FAILURE";

export const UPDATE_NEWS_GENERATION_RECORD = "UPDATE_NEWS_GENERATION_RECORD";
export const UPDATE_NEWS_GENERATION_RECORD_SUCCESS =
  "UPDATE_NEWS_GENERATION_RECORD_SUCCESS";
export const UPDATE_NEWS_GENERATION_RECORD_FAILURE =
  "UPDATE_NEWS_GENERATION_RECORD_FAILURE";

export const DELETE_NEWS_GENERATION_RECORD = "DELETE_NEWS_GENERATION_RECORD";
export const DELETE_NEWS_GENERATION_RECORD_SUCCESS =
  "DELETE_NEWS_GENERATION_RECORD_SUCCESS";
export const DELETE_NEWS_GENERATION_RECORD_FAILURE =
  "DELETE_NEWS_GENERATION_RECORD_FAILURE";

export const GET_NEWS_GENERATION_RECORD = "GET_NEWS_GENERATION_RECORD";
export const GET_NEWS_GENERATION_RECORD_SUCCESS =
  "GET_NEWS_GENERATION_RECORD_SUCCESS";
export const GET_NEWS_GENERATION_RECORD_FAILURE =
  "GET_NEWS_GENERATION_RECORD_FAILURE";

export const LIST_NEWS_GENERATION_RECORDS = "LIST_NEWS_GENERATION_RECORDS";
export const LIST_NEWS_GENERATION_RECORDS_SUCCESS =
  "LIST_NEWS_GENERATION_RECORDS_SUCCESS";
export const LIST_NEWS_GENERATION_RECORDS_FAILURE =
  "LIST_NEWS_GENERATION_RECORDS_FAILURE";

// News Generation Action Creators

// Create a new news generation record
export const createNewsGenerationRecord = (newsGenerationInput) => ({
  type: CREATE_NEWS_GENERATION_RECORD,
  payload: newsGenerationInput,
});

// Successful news generation record creation
export const createNewsGenerationRecordSuccess = (response) => ({
  type: CREATE_NEWS_GENERATION_RECORD_SUCCESS,
  payload: response,
});

// News generation record creation failure
export const createNewsGenerationRecordFailure = (error) => ({
  type: CREATE_NEWS_GENERATION_RECORD_FAILURE,
  error,
});

// Update an existing news generation record
export const updateNewsGenerationRecord = (newsGenerationInput) => ({
  type: UPDATE_NEWS_GENERATION_RECORD,
  payload: newsGenerationInput,
});

// Successful news generation record update
export const updateNewsGenerationRecordSuccess = (response) => ({
  type: UPDATE_NEWS_GENERATION_RECORD_SUCCESS,
  payload: response,
});

// News generation record update failure
export const updateNewsGenerationRecordFailure = (error) => ({
  type: UPDATE_NEWS_GENERATION_RECORD_FAILURE,
  error,
});

// Delete a news generation record
export const deleteNewsGenerationRecord = (newsId, tenantId) => ({
  type: DELETE_NEWS_GENERATION_RECORD,
  payload: { newsId, tenantId },
});

// Successful news generation record deletion
export const deleteNewsGenerationRecordSuccess = (response) => ({
  type: DELETE_NEWS_GENERATION_RECORD_SUCCESS,
  payload: response,
});

// News generation record deletion failure
export const deleteNewsGenerationRecordFailure = (error) => ({
  type: DELETE_NEWS_GENERATION_RECORD_FAILURE,
  error,
});

// Retrieve a single news generation record
export const getNewsGenerationRecord = (newsId, tenantId) => ({
  type: GET_NEWS_GENERATION_RECORD,
  payload: { newsId, tenantId },
});

// Successful news generation record retrieval
export const getNewsGenerationRecordSuccess = (newsGenerationRecord) => ({
  type: GET_NEWS_GENERATION_RECORD_SUCCESS,
  payload: newsGenerationRecord,
});

// News generation record retrieval failure
export const getNewsGenerationRecordFailure = (error) => ({
  type: GET_NEWS_GENERATION_RECORD_FAILURE,
  error,
});

// List news generation records
export const listNewsGenerationRecords = (tenantId, status, limit) => ({
  type: LIST_NEWS_GENERATION_RECORDS,
  payload: { tenantId, status, limit },
});

// Successful news generation records listing
export const listNewsGenerationRecordsSuccess = (
  newsGenerationRecordsConnection
) => ({
  type: LIST_NEWS_GENERATION_RECORDS_SUCCESS,
  payload: newsGenerationRecordsConnection,
});

// News generation records listing failure
export const listNewsGenerationRecordsFailure = (error) => ({
  type: LIST_NEWS_GENERATION_RECORDS_FAILURE,
  error,
});
